
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.997 17.625h-2.38v-3.736c0-.892-.017-2.038-1.238-2.038-1.239 0-1.428.97-1.428 1.972v3.802h-2.38V9.941h2.284v1.05h.032c.318-.604 1.095-1.241 2.254-1.241 2.411 0 2.856 1.591 2.856 3.661v4.214zM7.803 9a1.379 1.379 0 01-1.385-1.375c0-.76.617-1.375 1.385-1.375a1.38 1.38 0 011.384 1.375A1.38 1.38 0 017.803 9zm-1.134 8.625h2.392V10H6.669v7.625zM19.196 4H5.466c-.656 0-1.188.517-1.188 1.153v13.693c0 .638.532 1.154 1.188 1.154h13.73c.656 0 1.193-.516 1.193-1.154V5.153c0-.636-.537-1.153-1.193-1.153z","fill":"currentColor"}})])
          )
        }
      }
    